<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5h1.5a2.5 2.5 0 0 0 0-5h-4L4 5H2.5a2.5 2.5 0 1 0 0 5h4L10 5ZM5.85 8.75l3.5-5h2.15a1.25 1.25 0 0 0 0-2.5H8.15l-3.5 5H2.5a1.25 1.25 0 0 0 0 2.5h3.35Z" fill="currentColor"/>
</svg>
